import React, { useEffect } from 'react'
import { useCart } from 'cart/CartProvider'
import { useNavigate } from 'react-router-dom'
import { useAuth } from './AuthProvider'

const Logout: React.FC = () => {
  const auth = useAuth()
  const [cart, cartAct] = useCart()
  const navigate = useNavigate()

  useEffect(() => {
    if (cart) {
      auth.setUser(null)
      cartAct.refresh()
      navigate('/')
    }
  }, [cart, cartAct, auth, navigate])
  return <div></div>
}
export default Logout
